export default __webpack_public_path__ + "static/media/stretch1.4a2a3401.jpg";